const Shared = {
    selectors: {
        "thumbnails": { selector: ".thumbnail", type: "all", scope: "document" },
        "gripSelects": { selector: ".grip_type_pdp", type: "all", scope: "document" },
        "gripGuideBtn": { selector: "#grip-guide-btn", type: "single", scope: "document" },
        "gripGuide": { selector: "#grip-guide", type: "single", scope: "document" },
        "allSwatches": { selector: ".swatch-btn", type: "all", scope: "document" },
        "pricesMain": { selector: ".product-page-template .prices", type: "single", scope: "document" },
        "optSelectedCustom": { selector: ".customization-swatch .option-selected", type: "single", scope: "document" },
        "swatchesCustom": { selector: ".swatch-btn-Customizations", type: "all", scope: "document" },
        "backInStockInput": { selector: ".back-in-stock-notify", type: "single", scope: "document" },
        "outOfStockBtn": { selector: ".out-of-stock-main", type: "single", scope: "document" },
        "stockAlert": { selector: ".stock-alert", type: "single", scope: "document" },
        "inventoryBullet": { selector: ".bullet-point", type: "single", scope: "document" },
        "loadingSpinner": { selector: ".icon-loading-js", type: "single", scope: "document" },
        "modalBg": { selector: ".modal-background", type: "single", scope: "document" },
        "modelInfo": { selector: ".model-info", type: "all", scope: "document" }
    },
  
    init: async function(handle, variantId, okendoId, productId, productType, retired) { 
        this.productType = productType;
        Utility.fetchEls(this.selectors, this);
        this.initEventListeners();
    },

    initEventListeners: function() {
        const {
            allSwatches,
            thumbnails,
            productType
        } = this;

        if (!this.modelInfo.length || window.innerWidth < 1200) {
          this.initImageGalleryEventListeners();
          if (thumbnails) {
              thumbnails.forEach((thumbnail) => {
                thumbnail.addEventListener('click', (event) => {
                    this.updateSelectedImage(event.target, false);
                });
              });
            }
        }
        
    },
    
    initQuantityEventListeners: function(modal = false) {
        let minusBtns;
        let plusBtns;
        let productDetails;
        if (modal) {
            minusBtns = Modal.minusBtns;
            plusBtns = Modal.plusBtns;
            productDetails = Modal.productDetails;
        } else {
            minusBtns = ProductPage.minusBtns;
            plusBtns = ProductPage.plusBtns;
            productDetails = ProductPage.productDetails;
        }
        minusBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                this.handleQuantityChange(btn, 'decrease', modal);
            });
        });
        plusBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                this.handleQuantityChange(btn, 'increase', modal);
            });
        });
    },
    
    updateImageGallery: async function(modal = false, variantId = ProductPage.getVariantFromUrl(ProductPage.productData).id, handle, modelInfoParts) {
      let images = await Utility.fetchProductImages(handle, variantId);
      const adImage = ProductPage.productPhotos.getAttribute('data-ad-image');
      const currentVariantId = ProductPage.productPhotos.getAttribute('data-variant-id');

      // Only show the Ad Image in the product images for the default color selected
      if (adImage && currentVariantId && variantId === currentVariantId) {
        // Ensure the image isn't already in the array
        if (!images.includes(adImage)) {
        images.unshift(adImage); // Add as first image
        }
      }

      let selected;
      let thumbnails;
      let productData;
      if (modal) {
          selected = Modal.selected;
          thumbnails = Modal.thumbnails;
          productData = Modal.productData;
      } else {
          selected = ProductPage.selected;
          thumbnails = ProductPage.thumbnails;
          productData = ProductPage.productData;
      }

      if (!thumbnails) {
        return;
      }
    
      const imageEls = selected.querySelectorAll('img');
      imageEls.forEach((image) => {
        image.remove();
      });
      thumbnails.innerHTML = '';

      if (this.productType == 'Apparel' && modelInfoParts) {
        // populate the HTML with the images
        images.forEach((image, index) => {
            let element = document.createElement('img');
            element.alt = productData.title;
            element.src = image.replace('&width=300', '');
            if (index === 0) {
                selected.prepend(element.cloneNode(true));
                element.classList.add('active');
                const newDiv = document.createElement('div');
                newDiv.appendChild(element);
                element = newDiv;
                const modelInfoDesktop = document.createElement('div');
                const modelInfoMobile = document.createElement('div');
                
                // Configure Desktop Model Info
                modelInfoDesktop.classList.add('model-info');
                modelInfoDesktop.classList.add('desktop');
                modelInfoDesktop.innerHTML = `<p>Model is ${modelInfoParts[0]} wearing ${modelInfoParts[1]}</p>`;
                
                // Configure Mobile Model Info
                modelInfoMobile.classList.add('model-info');
                modelInfoMobile.classList.add('mobile');
                modelInfoMobile.innerHTML = `<p>Model is ${modelInfoParts[0]} wearing ${modelInfoParts[1]}</p>`;
                
                element.appendChild(modelInfoDesktop);
                element.appendChild(modelInfoMobile);
            } 
            element.height = 'auto';
            element.width = '100%';
            element.classList.add(`${modal ? 'modal-thumbnail' : 'thumbnail'}`);
            if (this.productType == 'Apparel') {
              element.classList.add('clothing-thumbnail');
            }
            element.setAttribute('data-thumbnail-id', index);
            element.setAttribute('tabindex', 0);
            element.setAttribute('role', 'button');
            element.setAttribute('aria-label', 'Click to select this image.')
            element.addEventListener('click', (event) => {
                this.updateSelectedImage(event.target, modal);
            });
            thumbnails.appendChild(element);
        });
        initializeGalleryEventListeners();
      } else {
        // populate the HTML with the images
        images.forEach((image, index) => {
            const element = document.createElement('img');
            element.alt = productData.title;
            if (index === 0) {
                element.src = image.replace('&width=300', '');
                selected.prepend(element.cloneNode(true));
                element.classList.add('active');
            } 
            element.height = 'auto';
            element.width = '75px';
            element.src = image;
            element.classList.add(`${modal ? 'modal-thumbnail' : 'thumbnail'}`);
            if (this.productType == 'Apparel') {
              element.classList.add('clothing-thumbnail');
            }
            element.setAttribute('data-thumbnail-id', index);
            element.setAttribute('tabindex', 0);
            element.setAttribute('role', 'button');
            element.setAttribute('aria-label', 'Click to select this image.')
            element.addEventListener('click', (event) => {
                this.updateSelectedImage(event.target, modal);
            });
            thumbnails.appendChild(element);
        });
      }

      ProductPage.thumbnailImages = thumbnails.querySelectorAll('.thumbnail');
    },
    
    initImageGalleryEventListeners: function() {
        this.initKeyDownEventListeners();
        this.initArrowEventListeners();
    },
    
    initArrowEventListeners: function() {
      let modalView = false;
      let modal;
      if (typeof Modal !== 'undefined' && Modal) {
        modal = Modal.modal;
      }
      if (modal) {
        const modalStyle = window.getComputedStyle(modal);
        const modalDisplay = modalStyle.display;
        if (modalDisplay === 'block') {
          modalView = true;
        }
      }
      let parent;
      if (modalView) {
          parent = Modal.parent;
      } else {
          parent = document.querySelector('.product-imgs-container');
      }      
      const thumbnailArrows = parent.querySelectorAll('.thumbnail-arrow');
      thumbnailArrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
          let clickedArrow = arrow;
          if (arrow.tagName !== 'SVG') {
            clickedArrow = arrow.querySelector('svg');
          }
          const direction = clickedArrow.dataset.icon;
          if (direction.includes('left')) {
            this.goToPreviousImage(modalView);
          } else if (direction.includes('right')) {
            this.goToNextImage(modalView);
          }
        });
      });
    },
    
    initKeyDownEventListeners: function() {
      document.addEventListener('keydown', (event) => {
          let modalView = false;
          const {modal} = this;
          let modalStyle;
          let modalDisplay;
          if (modal) {
            modalStyle = window.getComputedStyle(modal);
            modalDisplay = modalStyle.display;
          }
          if (modalDisplay === 'block') {
            modalView = true;
          }
          if (event.key === 'ArrowRight') {
            this.goToNextImage(modalView);
          } else if (event.key === 'ArrowLeft') {
            this.goToPreviousImage(modalView);
          }
      });
    },
    
    goToNextImage: function(modal) {
      let thumbnails;
      let thumbnailContainer;
      if (modal) {
          thumbnails = Modal.thumbnailImages;
          thumbnailContainer = Modal.thumbnails;
      } else {
          thumbnails = ProductPage.thumbnailImages;
          thumbnailContainer = ProductPage.thumbnails;
      }
        const currentIndex = thumbnailContainer.querySelector('.active').dataset.thumbnailId;

        let nextIndex = (parseInt(currentIndex) + 1);

        if (nextIndex > thumbnails.length - 1) {
            nextIndex = 0;
            Utility.smoothScroll(thumbnailContainer, -(thumbnailContainer.scrollWidth - thumbnailContainer.clientWidth), 300);
        } else {
            Utility.smoothScroll(thumbnailContainer, 75, 300);
        }
        this.updateSelectedImage(thumbnails[nextIndex], modal);
    },
    
    goToPreviousImage: function(modal) {
        let thumbnails;
        let thumbnailContainer;
        if (modal) {
            thumbnails = Modal.thumbnailImages;
            thumbnailContainer = Modal.thumbnails;
        } else {
            thumbnails = ProductPage.thumbnailImages;
            thumbnailContainer = ProductPage.thumbnails;
        }
        const currentIndex = thumbnailContainer.querySelector('.active').dataset.thumbnailId;
        let prevIndex = (parseInt(currentIndex) - 1);

        if (prevIndex < 0) {
            prevIndex = thumbnails.length - 1;
            Utility.smoothScroll(thumbnailContainer, thumbnailContainer.scrollWidth - thumbnailContainer.clientWidth, 300);
        } else {
            Utility.smoothScroll(thumbnailContainer, -75, 300);
        }
        this.updateSelectedImage(thumbnails[prevIndex], modal);
    },
    
    updateSelectedImage: function(thumbnail, modal) {
        let selected;
        let thumbnails;
        if (modal) {
            selected = Modal.selected;
            thumbnails = Modal.thumbnailImages;
        } else {
            selected = ProductPage.selected;
            thumbnails = ProductPage.thumbnailImages;
        }
        const imgSrc = thumbnail.src.replace('&width=300', '').replace('&width=500', '');
        const altText = thumbnail.alt;
        thumbnails.forEach((thumb) => {
            thumb.classList.remove('active');
        });
        thumbnail.classList.add('active');

        const imgEls = selected.querySelectorAll('img');
        imgEls.forEach((el) => {
          el.src = imgSrc;
          el.alt = altText;
        });
    },
    
    handleOutOfStock: async function(modal=false, variantId = ProductPage.getVariantFromUrl(ProductPage.productData).id) {
        let addToCartBtn;
        let productData;
        if (modal) {
            addToCartBtn = Modal.addToCartBtn;
            productData = Modal.productData;
        } else {
            addToCartBtn = ProductPage.addToCartBtn;
            productData = ProductPage.productData;
        }
        const {outOfStockBtn, stockAlert, inventoryBullet, backInStockInput} = this;
        const variantDetails = await Utility.fetchProductDetails(productData.handle, variantId);
        const curVariant = productData.variants.find((variant) => variant.id == variantId);

        let productAvailable = variantDetails.available;

        if (!productAvailable) {
            if (!modal) {
                addToCartBtn.style.display = 'none';
                if (outOfStockBtn) {
                  outOfStockBtn.style.display = 'block';
                }
                if (stockAlert) {
                  stockAlert.style.fontWeight = '400';
                  stockAlert.textContent = 'Out of stock - sign up to be notified when back in stock';
                }
                if (inventoryBullet) {
                  inventoryBullet.style.color = 'red';
                }
                if (backInStockInput) {
                  backInStockInput.style.display = 'flex';
                }
            } else {
                addToCartBtn.disabled = true;
                addToCartBtn.classList.add('out-of-stock');
                addToCartBtn.textContent = 'Out of Stock';
            }
        } else {
            if (!modal) {
                addToCartBtn.style.display = 'block';
                if (outOfStockBtn) {
                  outOfStockBtn.style.display = 'none';
                }
                if (stockAlert) {
                  if (variantDetails.shippingDelay != "") {
                    stockAlert.textContent = 'Shipping in ' + variantDetails.shippingDelay;
                    stockAlert.style.fontWeight = '700';
                  } else {
                      stockAlert.style.fontWeight = '400';
                      stockAlert.textContent = variantDetails.inventory == undefined || variantDetails.inventory > 10 || variantDetails.inventory < 1 ? 'In stock, ready to ship' : `Hurry! Only ${variantDetails.inventory} left`;
                  }
                }
                if (inventoryBullet) {
                  if (variantDetails.shippingDelay != "") {
                    inventoryBullet.style.color = `red`;
                  } else {
                      inventoryBullet.style.color = variantDetails.inventory == undefined || variantDetails.inventory > 10 || variantDetails.inventory < 1 ? 'green' : `red`;
                  }
                }
                if (backInStockInput) {
                  backInStockInput.style.display = 'none';
                }
              } else {
                addToCartBtn.disabled = false;
                addToCartBtn.classList.remove('out-of-stock');
                addToCartBtn.textContent = addToCartBtn.value;
            }
        }
    },
    
    initSwatchesStock: async function (productData, modal=false, curVariant = ProductPage.getVariantFromUrl(ProductPage.productData).id) {
        let parent;
        if (modal) {
            parent = Modal.parent;
        } else {
            parent = ProductPage.parent;
        }
        const selectedSwatch = parent.querySelector('.swatch-btn.selected');
        this.updateSwatchesStock(selectedSwatch.dataset.swatchValue, selectedSwatch.dataset.optionName, modal);
        this.updateSwatchesExist(selectedSwatch.dataset.swatchValue, selectedSwatch.dataset.optionName, modal)
    },
    
    generateCombinations: function(options, optionIndex = 0, previousCombination = []) {
        if (optionIndex === options.length) {
            return [previousCombination];
        }
    
        const allCombinations = [];
        const currentOption = options[optionIndex];
    
        currentOption.values.forEach(value => {
            const newCombination = [...previousCombination, value];
            const combinationsFromHere = this.generateCombinations(options, optionIndex + 1, newCombination);
            allCombinations.push(...combinationsFromHere);
        });
    
        return allCombinations;
    },
    
    updateSwatchesStock: async function(swatchValue, optionName, modal = false, fbt = null) {
        let parent;
        let productData;
        let allSwatches;
        if (modal) {
            parent = Modal.parent;
            productData = Modal.productData;
            allSwatches = Modal.allSwatches;
        } else if (fbt) {
            parent = fbt.closest('.fbt-product-card');
            allSwatches = parent.querySelectorAll('.swatch-fbt');
            productData = ProductPage.fbtProductData;
            if (!productData) {
                productData = await Utility.fetchProductDataAjax(fbt.dataset.handle);
            }
        } else {
            parent = ProductPage.parent;
            productData = ProductPage.productData;
            allSwatches = ProductPage.allSwatches;
        }
        let outOfStock = [];
        const allOpts = productData.options.filter((option) => option.name != 'Customizations');
        const optsCount = allOpts.length;
        let lastOptionSwatches;

         if (optsCount === 1) {
           lastOptionSwatches = allSwatches;
           const swatchValues = productData.options[0].values;
            productData.variants.forEach((variant) => {
                const variantTitleOpts = variant.title.split(' / ').map(v => v.trim());
                
                swatchValues.forEach((value) => {
                    if (variantTitleOpts.includes(value.trim())) {
                        let inStock = variant.available;
                        if (!inStock) {
                            outOfStock.push(value);
                        }
                    }
                });
            });
        } else {
            // Get all current selections except for the last option
            const currentSelections = Array.from(parent.querySelectorAll('.swatch-btn.selected'))
                                            .filter(swatch => swatch.dataset.optionName !== productData.options[optsCount - 1].name)
                                            .map(swatch => swatch.dataset.swatchValue.trim());

            const lastOption = productData.options[optsCount - 1];
            lastOptionSwatches = Array.from(parent.querySelectorAll(`.swatch-btn[data-option-name="${lastOption.name}"]`));

            lastOptionSwatches.forEach(swatch => {
                const testCombination = [...currentSelections, swatch.dataset.swatchValue.trim()].filter(Boolean);

                const matchingVariant = productData.variants.find(variant => {
                    const variantTitleParts = variant.title.split(' / ').map(v => v.trim());

                    let isMatch = testCombination.every(option => {
                        const match = variantTitleParts.includes(option);
                        return match;
                    });
                    return isMatch;
                });
                if (matchingVariant) {
                  let inStock = matchingVariant.available;
                  if (!inStock) {
                      outOfStock.push(swatch.dataset.swatchValue);
                  }
                }
            });
        }
        lastOptionSwatches.forEach((swatch) => {
            if (outOfStock.includes(swatch.dataset.swatchValue)) {
                swatch.classList.add('disabled');
                // Update text only for dropdown options, not for buttons
                if (swatch.tagName === 'OPTION') {
                    swatch.disabled = true; // Disable the swatch
                   if (!swatch.textContent.includes(' - out of stock')) {
                        swatch.textContent += ' - out of stock';
                    }
                }
            } else {
                swatch.disabled = false;
                swatch.classList.remove('disabled');
                // Update text only for dropdown options, not for buttons
                if (swatch.tagName === 'OPTION') {
                    swatch.textContent = swatch.textContent.replace(' - out of stock', '');
                }
            }
        });
    },

    
    variantExistsForCombination: function(combination, variants) {
        return variants.some(variant => {
            const variantOptions = variant.title.split(' / ');
            return combination.every(value => variantOptions.includes(value));
        });
    },

    updateSwatchesExist: function(swatchValue, optionName, modal = false) {
        let productData;
        let parent;
        if (modal) {
            productData = Modal.modalProductData;
            parent = Modal.parent;
        } else {
            productData = ProductPage.productData;
            parent = ProductPage.parent;
        }
    
        const optionsLength = productData.options.length;
    
        // Return if there are no relevant options or customizations
        if (optionsLength <= 1 || optionName == 'Customizations') {
            return;
        }
    
        // Select all swatches except for those with the class 'swatch-btn-Customizations'
        const allSwatches = Array.from(parent.querySelectorAll('.swatch-btn'))
                                  .filter(swatch => !swatch.classList.contains('swatch-btn-Customizations'));
    
        const unavailableValues = [];
    
        // Get currently selected values for all options except the last one
        const selectedButtons = allSwatches.filter(btn => btn.classList.contains('selected'));
        const lastSelectedBtn = selectedButtons.pop();
        const selectedValues = selectedButtons.map((btn) => btn.dataset.swatchValue);
        const lastSelectedValue = lastSelectedBtn ? lastSelectedBtn.dataset.swatchValue : null;
          
        // Get the last option
        let lastOption = productData.options[productData.options.length - 1];
        if (lastOption.name == 'Customizations') {
          lastOption = productData.options[productData.options.length - 2];
        }
        const lastOptionSwatches = Array.from(parent.querySelectorAll(`.swatch-btn[data-option-name="${lastOption.name}"]`))
                                         .filter(swatch => !swatch.classList.contains('swatch-btn-Customizations'));
    
        lastOptionSwatches.forEach(swatch => {
            const testCombination = [...selectedValues, swatch.dataset.swatchValue];
            // Check if this combination is available
            if (!this.variantExistsForCombination(testCombination, productData.variants)) {
                unavailableValues.push(swatch.dataset.swatchValue);
            }
        });
    
        // Update swatch visibility based on availability
        lastOptionSwatches.forEach((swatch) => {
            if (unavailableValues.includes(swatch.dataset.swatchValue)) {
                swatch.disabled = true; // Disable swatch if it's an OPTION tag or similar
                swatch.style.display = 'none'; // Hide swatch if it's a visual element
            } else {
                swatch.disabled = false;
                swatch.style.display = 'block';
            }
        });
    
        if (lastSelectedValue && unavailableValues.includes(lastSelectedValue)) {
            const nextAvailableSwatch = lastOptionSwatches.find(swatch => !unavailableValues.includes(swatch.dataset.swatchValue));
            if (nextAvailableSwatch) {
                nextAvailableSwatch.classList.add('selected'); 
                const selectedText = nextAvailableSwatch.closest('.swatch').querySelector('.option-selected');
                selectedText.textContent = nextAvailableSwatch.dataset.swatchValue;
                if (lastSelectedBtn) {
                    lastSelectedBtn.classList.remove('selected');
                }
            }
        }
    
        const dropdownSwatch = allSwatches.find((swatch) => swatch.tagName === 'OPTION');
        if (dropdownSwatch && unavailableValues.length) {
            const select = dropdownSwatch.closest('select'); 
            const allOpts = Array.from(select.options);
            const selectedOpt = select.value;
            const selectedSwatch = allOpts.find((opt) => opt.value == selectedOpt);
            if (selectedSwatch.disabled) {
                select.setAttribute('data-force-change', true);
                const firstAvailableOption = allOpts.find(option => !option.disabled);
                select.value = firstAvailableOption.value;
                const event = new Event('change', {
                    bubbles: true,
                    cancelable: true,
                });
                select.dispatchEvent(event);
            }
        }
    },
    
    handleSwatchChange: async function(swatch, modal = false, fbt = false) {
        let variantIdInput;
        let parent;
        let addToCartBtn;
        let productData;
        let announcementBar = document.querySelector('.announcement-bg');
        let idInput;
        let prices;
        let urls;
        const retired = ProductPage.retired;

        const {
          productTitleH1, 
          ogTitleWithShape, 
          ogImage, 
          ogImageSecureUrl, 
          behindProdAcc,
          featuresAcc,
          techSpecsAcc,
          detailsCareAcc
        } = ProductPage;
      
        const isButton = swatch.tagName === 'BUTTON';

        if (modal) {
            variantIdInput = Modal.idInput;
            parent = Modal.parent;
            addToCartBtn = Modal.addToCartBtn;
            productData = Modal.productData;
            prices = parent.querySelector('.prices');
        } else if (fbt) {
            parent = swatch.closest('.fbt-product-card');
            if (!parent) return;
    
            addToCartBtn = parent.querySelector('.quick-add');
            addToCartBtn.disabled = true;
            prices = parent.querySelector('.prices');
            urls = parent.querySelectorAll('.fbt-url');
    
            swatch = isButton ? swatch : swatch.querySelector('option:checked');
            const handle = swatch.dataset.handle;
    
            try {
                productData = await Utility.fetchProductDataAjax(handle);
            } catch (error) {
                console.error('Error fetching product data:', error);
                return;
            }
          
            variantIdInput = parent.querySelector('.fbt-id-input');    
        } else {
            variantIdInput = ProductPage.idInput;
            parent = ProductPage.parent;
            addToCartBtn = ProductPage.addToCartBtn;
            productData = ProductPage.productData;
            prices = ProductPage.pricesMain;
        }
    
        const saveBtn = parent.querySelector('.save-btn');
        if (saveBtn) {
            saveBtn.disabled = true;
        }
    
        let selectedOptions;
        const quantitySelector = parent.querySelector('.quantity');
        let selectedBtn = swatch;
        let select;
        if (selectedBtn.tagName === 'IMG') {
            selectedBtn = selectedBtn.closest('button');
        } else if (selectedBtn.tagName === 'SELECT') {
            select = selectedBtn;
            selectedBtn = selectedBtn.selectedOptions[0];
        } else if (selectedBtn.tagNAme === 'OPTION') {
            select = selectedBtn.closest('select');
        }
        const optionName = selectedBtn.dataset.optionName;
        const swatchValue = selectedBtn.dataset.swatchValue;
        const selectedSwatchText = parent.querySelector(`#${optionName}-selected`);
        if (selectedSwatchText) {
            selectedSwatchText.textContent = swatchValue;
        }
    
        if (select && select.getAttribute('data-force-change') !== 'true' || !select) {
            selectedOptions = this.updateSelectedSwatches(parent, optionName, selectedBtn, fbt);
            this.updateSwatchesExist(swatchValue, optionName, modal);
        } else if (select && select.getAttribute('data-force-change') == 'true') {
            select.setAttribute('data-force-change', false);
        }

        selectedOptions = this.updateSelectedSwatches(parent, optionName, selectedBtn, fbt);

        const matchingVariant = productData.variants.find((variant) => {
            // Check if the product title contains 'Slide'
            const isSlideProduct = productData.title.toLowerCase().includes('slide');
            const isRecoveryShoeProduct = productData.title.toLowerCase().includes('renew') && productData.title.toLowerCase().includes('recovery');

            // Split the variant title into an array of attributes
            const variantAttributes = variant.title.split('/').map(attr => attr.trim().toLowerCase());

            let normalizedSelectedOptions;

            if (isSlideProduct || isRecoveryShoeProduct) {
                // Normalize the size by splitting 'M6/W8' into ['m6', 'w8']
                normalizedSelectedOptions = selectedOptions.map(option => {
                    if (option.includes('/')) {
                        // Split size like 'M6/W8' into ['m6', 'w8']
                        return option.split('/').map(size => size.trim().toLowerCase());
                    } else {
                        return option.toLowerCase();
                    }
                }).flat(); // Flatten the array in case the size was split
            } else {
                // Just use selectedOptions as is
                normalizedSelectedOptions = selectedOptions.map(option => option.toLowerCase());
            }

            // Ensure the selected options match the variant attributes
            const isMatch = normalizedSelectedOptions.every(option => {
                return variantAttributes.some(variantAttr => variantAttr === option);
            });

            return isMatch;
        });

        if (!matchingVariant) {
            console.error('No matching variant found for selected options:', selectedOptions);
            return;
        } 
          
        const variantData = await Utility.fetchProductDetails(productData.handle, matchingVariant.id);
        if (modal) {
            Modal.productDetails = variantData;
        } else {
            ProductPage.productDetails = variantData;
        }

      
        if (!retired && !fbt) {
          variantIdInput.value = matchingVariant.id;
          quantitySelector.querySelector('#main-quantity').value = 1;
          if (optionName == 'Weight') {
              this.initCustomizations(modal, matchingVariant);
          }
        }

        if (!modal && !fbt) {
            if (optionName === 'Shape') {
                  this.selectedShape = document.querySelector('.swatch-btn-Shape.selected').dataset.swatchValue;
                  ProductPage.updateShapeGuide();
                  ogTitleWithShape.setAttribute('content', productData.title + ' - ' + swatchValue);
                  ogImage.setAttribute('content', matchingVariant.featured_image.src);
                  ogImageSecureUrl.setAttribute('content', matchingVariant.featured_image.src);
                  productTitleH1.textContent = productData.title + ' - ' + swatchValue;
                  if (variantData.behindTheProduct && behindProdAcc) {
                      behindProdAcc.innerHTML = variantData.behindTheProduct;
                  }
                  if (variantData.productFeatures && featuresAcc) {
                      featuresAcc.innerHTML = variantData.productFeatures;
                  }
                  if (variantData.techSpecs && techSpecsAcc) {
                      techSpecsAcc.innerHTML = variantData.techSpecs;
                  }
                  if (variantData.detailsCare && detailsCareAcc) {
                      detailsCareAcc.innerHTML = variantData.detailsCare;
                  }
                }
            if (optionName === 'Color' || optionName === 'Design') {
                const gcImage = document.querySelector('.gc-image img');
                if (gcImage) {
                    gcImage.src = matchingVariant.featured_image.src;
                }
                // START AMPED PRO AIR SPECIFIC
                if (optionName === 'Color' && productData.title.includes('Pro Air')) {
                    announcementBar.style.backgroundColor = selectedBtn.dataset.bgColor;
                    addToCartBtn.style.backgroundColor = selectedBtn.dataset.bgColor;
                    const fbtProducts = document.querySelectorAll('.fbt-product-card');
                    fbtProducts.forEach((product) => {
                        const swatches = product.querySelectorAll('.swatch-fbt');
                        let swatchToSelect = null;
                        Array.from(swatches).forEach((swatch) => {
                            if (swatch.dataset.swatchValue.includes(swatchValue)) {
                                swatchToSelect = swatch;
                            } else if(swatchValue == 'Silver') {
                                if (swatch.dataset.swatchValue.includes('Black')) {
                                    swatchToSelect = swatch;
                                }
                            }
                        });
                        if (swatchToSelect) {
                            swatchToSelect.click();
                        }
                    });
                }
                // END AMPED PRO AIR SPECIFIC
            }
            prices.forEach((price) => {
              price.innerHTML = matchingVariant.compare_at_price 
                ? `<span class="compare-price">$${(matchingVariant.compare_at_price / 100).toFixed(2).replace(/\.00$/, '')}</span><span class="price on-sale">$${(matchingVariant.price / 100).toFixed(2).replace(/\.00$/, '')}</span>` 
                : `<span class="price">$${(matchingVariant.price / 100).toFixed(2).replace(/\.00$/, '')}</span>`;
            });
          
            if (addToCartBtn) {
              addToCartBtn.textContent = 'Add to Cart';
            }
            const url = new URL(window.location.href);
            url.searchParams.set('variant', matchingVariant.id);
            window.history.pushState({ path: url.toString() }, '', url.toString());
        }
      if (!fbt) {
        if (this.productType == 'Apparel' && variantData.modelInfo) {
          this.modelInfoParts = variantData.modelInfo.split(' | ');
        }
        this.updateImageGallery(modal, matchingVariant.id, productData.handle, this.modelInfoParts);
        if (!retired) {
          this.updateSwatchesStock(swatchValue, optionName, modal);
          this.handleOutOfStock(modal, matchingVariant.id);
          this.toggleCustomizations(productData, matchingVariant, modal)
        }
      }
    
        const gripError = parent.querySelector('.grip-error');
        const weightError = parent.querySelector('.weight-error');
        if (gripError) {
            gripError.style.display = 'none';
        }
        if (weightError) {
            weightError.style.display = 'none';
        }
    
        if (saveBtn) {
            saveBtn.disabled = false;
        }
    
        if (fbt) {
            urls.forEach((url => url.href="/products/" + productData.handle + "?variant=" + matchingVariant.id));
            variantIdInput.value = matchingVariant.id;
            const image = parent.querySelector('.fbt-image');
            if (optionName == 'Color') {
              image.src = swatch.dataset.image;
              image.alt = swatch.dataset.imageAlt;
            }
            if (matchingVariant.available) {
                addToCartBtn.textContent = `Quick Add`;
                addToCartBtn.disabled = false;
                addToCartBtn.classList.remove('out-of-stock');
            } else {
                addToCartBtn.disabled = true;
                addToCartBtn.textContent = 'Out of Stock';
                addToCartBtn.classList.add('out-of-stock');
            }
            // toggle swatch visibility
            if (optionName == 'Shape') {
                const colorSwatches = parent.querySelectorAll('.swatch-btn-Color');
                const filteredVariants = productData.variants.filter(variant => variant.title.includes(swatchValue));
                const filteredSwatches = Array.from(colorSwatches).filter(swatch => {
                    const swatchValue = swatch.dataset.swatchValue;
                    return filteredVariants.some(variant => variant.title.includes(swatchValue));
                });
                colorSwatches.forEach((swatch) => {
                    if (filteredSwatches.includes(swatch)) {
                        swatch.classList.remove('hide-swatch');
                    } else {
                        swatch.classList.add('hide-swatch');
                    }
                });
            }
        }
    },
    
    updateSelectedSwatches: function(parent, optionName, selectedBtn, fbt = false) {
      const allOptionSwatches = parent.querySelectorAll(`.swatch-btn-${optionName}`);
      // Update selected swatch to 'selected' class styling
      allOptionSwatches.forEach((swatch) => {
          swatch.classList.remove('selected');
      });
      selectedBtn.classList.add('selected');
    
      // Loop through all swatches to find the ones currently selected
      let allSwatches;
      if (fbt) {
        allSwatches = parent.querySelectorAll('.swatch-fbt');
      } else {
        allSwatches = parent.querySelectorAll('.swatch-btn');
      }
      let selectedOptions = [];
      allSwatches.forEach((swatch) => {
          if (swatch.classList.contains('selected')){
              selectedOptions.push(swatch.dataset.swatchValue);
          }
      });
      return selectedOptions;
    },
    
    handleQuantityChange: function(btn, operation, modal = false) {
        let addToCartBtn;
        let variantData;
        if (modal) {
            addToCartBtn = Modal.addToCartBtn;
            variantData = Modal.productDetails;
        } else {
            addToCartBtn = ProductPage.addToCartBtn;
            variantData = ProductPage.productDetails;
        }
        const container = btn.closest('.quantity');
        const input = container.querySelector('.number-input');
        let currentValue = parseInt(input.value, 10);    
        const inventory = variantData.inventory; 
        let newValue;
        if (operation === 'increase') {
            newValue = currentValue + 1;
        } else if (operation === 'decrease') {
            if (currentValue > 1) {
                newValue = currentValue - 1;
            }
        } 
        input.value = newValue;

        const price = (variantData.price * newValue / 100).toFixed(2).replace(/\.00$/, '')

        if ((inventory < 1 && variantData.available)|| input.value <= inventory) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = modal ? 'Quick Add - $' + price : 'Add to Cart';
        input.classList.remove('invalid-quantity');
        } else {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Quantity Unavailable'
            input.classList.add('invalid-quantity');
        }
    },
    
    initCustomizations: function(modal = false, variant) {
        const { gripSelects, gripGuideBtn, gripGuide } = this;
        let parent;
        let productData;
        let productDetails;
        if (modal) {
            parent = Modal.parent;
            productData = Modal.productData;
            productDetails = Modal.productDetails;
        } else {
            parent = ProductPage.parent;
            productData = ProductPage.productData;
            productDetails = ProductPage.productDetails;
        }
      
        const customBtn = parent.querySelector('.custom-header');

        //Check if it's a customizable product:
        const gripOpts = productDetails.gripOpts;
        const weightOpts = productDetails.weightOpts;
        const canCustomize = gripOpts || weightOpts;
        
        if (canCustomize) {
            gripSelects.forEach((select) => {
                select.addEventListener('change', () => {
                    const selectedGrip = select.value;
                    this.handleGripChange(selectedGrip, modal);
                });   
            });
        
            if (gripGuideBtn) {
                gripGuideBtn.addEventListener('click', function() {
                    gripGuide.style.display = 'block';
                });
            }
            if (!modal && !customBtn) {
                this.createCustomizationsBtn(parent, weightOpts);
            }
            this.weightSelect = parent.querySelector('.weight_range_pdp');
            this.gripSelect = parent.querySelector('.grip_type_pdp');
            this.saveBtn = parent.querySelector('.save-btn');
            this.selectedCustoms = parent.querySelector('.selected-custom');
            this.gripError = parent.querySelector('.grip-error');
            this.weightError = parent.querySelector('.weight-error');

            this.saveBtn.addEventListener('click', () => {
                this.handleSaveCustomizations(modal);
            });

            if (weightOpts) {
                this.createWeightOpts(weightOpts);
            }
            
            if (gripOpts) {
                this.createGripOptions(gripOpts);
            }
        }
        this.toggleCustomizations(productData, variant, modal);
    },
    
    createCustomizationsBtn: function(parent, weightOpts) {
        const { modalBg } = this;
        const customLink = document.createElement('div');
        customLink.classList.add('custom-header');
        let customLinkText = 'Customize Grip';
        if (weightOpts) {
          customLinkText = 'Customize Grip or Weight';
        }
        customLink.innerHTML = `<span class="customize-btn">${customLinkText}</span>
        <br>
        <span class="selected-custom"></span>`;
        const customizationSwatch = document.querySelector('.customization-swatch');
        customLink.addEventListener('click', function() {
            customizationSwatch.style.display = 'block';
            modalBg.style.display = 'block';
        });
        parent.querySelector('.product-variants').after(customLink);
    },
    
    createGripOptions: function(gripOpts) {
        const { gripSelect } = this;
        gripSelect.innerHTML = '<option name="default-grip" value="" selected="">Select a grip option...</option>';
        gripOpts.forEach(function(grip) {
            const parts = grip.split('|');
            let value = parts[0].trim();
            if (value.startsWith('"')) {
                value = value.slice(1);
            } else if (value.startsWith('["')) {
                value = value.slice(2);
            }
            let text = parts[1].trim().replace('"]', '');
            if (text.endsWith('"')) {
                text = text.slice(0, -1);
            }
        
            const optionElement = document.createElement('option');
            optionElement.value = value + ' (BTOG)';
            optionElement.textContent = text;
            gripSelect.appendChild(optionElement);
        });
    },
    
    createWeightOpts: function(weightOpts) {
        const { weightSelect } = this;
        weightSelect.innerHTML = '<option name="default-weight" value="" selected="">Select a weight option...</option>';
        weightOpts.forEach(function(weight) {
            const optionElement = document.createElement('option');
            optionElement.value = weight + ' (BTOW)';
            optionElement.textContent = weight;
            weightSelect.appendChild(optionElement);
        });
        this.resetEnabledWeights();
    },
    
    handleSaveCustomizations: function(modal) {
        const {gripSelect, weightSelect, saveBtn, selectedCustoms, modalBg, gripError, weightError} = this;
        let optionsSelected = true;
        let parent; 
        if (modal) {
          parent = Modal.parent;
        } else {
          parent = ProductPage.parent;
        }
      
        if (gripSelect.required && !gripSelect.value) {
            optionsSelected = false;
            if (gripError) {
                gripError.style.display = 'block';
            }
        }
        if (weightSelect.required && !weightSelect.value) {
            optionsSelected = false;
            if (weightError) {
                weightError.style.display = 'block';
            }
        }
        
        selectedCustoms.textContent = '';
        
        if (optionsSelected) {
            if (selectedCustoms) {
                const grip = gripSelect.value;
                const weight = weightSelect.value;
                if (grip || weight) {
                    selectedCustoms.textContent = 'Selected Customizations';
                }
                if (grip) {
                    const div = document.createElement('div');
                    div.innerHTML = `Custom Grip: ${grip.replace(' (BTOG)', '')}`
                    selectedCustoms.appendChild(div);
                }
                if (weight) {
                    const div = document.createElement('div');
                    div.innerHTML = `Custom Weight: ${weight.replace(' (BTOW)', '')}`
                    selectedCustoms.appendChild(div);
                }
            }
            if (!modal) {
                modalBg.style.display = 'none';
            }
            saveBtn.closest('.pdp-modal').style.display = 'none';
        }
    },
    
    resetEnabledWeights: function() {
        const { weightSelect } = this;
        const allWeightOpts = weightSelect.options;
        // Reset to default: always disable the 1st option (placeholder), disable the last 3 options, enable the rest
        for (let i = 0; i < allWeightOpts.length; i++) {
            if (i === 0 || i === 1 || i >= allWeightOpts.length - 3) { // Always disable the 1st option
                allWeightOpts[i].disabled = true;
                if (allWeightOpts[i].selected) {
                allWeightOpts[0].disabled = false;
                allWeightOpts[0].selected = true;
                }
                allWeightOpts[i].selected = false;
            } else {
                allWeightOpts[i].disabled = false;
            }
        }
    },
    
    toggleCustomizations: function(productData, selectedVariant = ProductPage.getVariantFromUrl(ProductPage.productData), modal = false) {
        const canCustomize = productData.options.some((option) => option.name == 'Customizations');
        if (canCustomize) {
            if(selectedVariant.title.includes("Custom Grip & Weight")) {
                this.showCustomOptionsPDP('Custom Grip & Weight +$10', modal);
            } else if(selectedVariant.title.includes("Custom Grip") && !selectedVariant.title.includes('Weight')) {
                this.showCustomOptionsPDP('Custom Grip +$5', modal);
            } else if(selectedVariant.title.includes("Custom Weight")) {
                this.showCustomOptionsPDP('Custom Weight +$5', modal);
            } else if(selectedVariant.title.includes('None')) {
                this.showCustomOptionsPDP('None', modal);
            }
        }
    },
    
    showCustomOptionsPDP: function(optionName, modal = false) {
        const { weightSelect, gripSelect, gripGuideBtn } = this;
        let parent;
        if (modal) {
            parent = Modal.parent;
        } else {
            parent = ProductPage.parent;
        }

        const gripOptions = parent.querySelector('.custom-grip-opts');
        const weightOptions = parent.querySelector('.custom-weight-opts');
      
        if (optionName == 'Custom Grip +$5') {
            gripSelect.required = true;
            gripOptions.style.display = 'block';
            weightOptions.style.display = 'none';
            weightSelect.required = false;
            weightSelect.value = "";
            if (gripGuideBtn) {
                this.populateGripGuide(gripGuideBtn);
            } 
        } else if(optionName == 'Custom Weight +$5') {
            this.resetEnabledWeights();
            weightSelect.required = true;
            weightOptions.style.display = 'block';
            weightSelect.disabled = false;
            gripOptions.style.display = 'none';
            gripSelect.value = "";
            gripSelect.required = false;
            if (gripGuideBtn) {
                gripGuideBtn.style.display = 'none';
            }
        } else if (optionName == 'Custom Grip & Weight +$10') {
            gripOptions.style.display = 'block';
            weightOptions.style.display = 'block';
            gripSelect.required = true;
            if (gripGuideBtn) {
                this.populateGripGuide(gripGuideBtn);
            } 
            weightSelect.required = true;
            if (!gripSelect.value) {
                weightSelect.disabled = true;
            }
        } else if(optionName == 'None') {
            weightSelect.required = false;
            weightSelect.value = "";
            gripSelect.value = "";
            gripOptions.style.display = 'none';
            weightOptions.style.display = 'none';
            gripSelect.required = false;
            if (gripGuideBtn) {
                gripGuideBtn.style.display = 'none';
            }
        }
      
    },
    
    populateGripGuide: function(gripGuideBtn) {
        const { gripSelect } = this;
        const gripDetails = document.querySelectorAll('.grip-details');
        const selectOptions = Array.from(gripSelect.options);
        const availableGrips = selectOptions.map((option) => option.value);
        gripDetails.forEach((grip) => {
        const foundGrip = availableGrips.find((opt) => opt.includes(grip.dataset.grip));
        if (foundGrip) {
            grip.style.display = 'block';
        }
        });
        gripGuideBtn.style.display = 'block';
    },
    
    handleGripChange: function(grip, modal) {
        let parent;
        if (modal) {
          parent = Modal.parent;
        } else {
          parent = ProductPage.parent;
        }
        const weightSelect = parent.querySelector('.weight_range_pdp');
        if (weightSelect) {
          weightSelect.disabled = false;
          const allWeightOpts = weightSelect.options;
          if (allWeightOpts.length > 1) {
              this.resetEnabledWeights();
              // Specific rules based on grip selection
              if (grip.includes('Thin')) {
                  // Enable the second weight option (since the first is a placeholder)
                  allWeightOpts[1].disabled = false;
              } else if (grip.includes('Double')) {
                  // Disable options 2-5 and enable the last 3
                  for (let i = 1; i < 5; i++) { // Adjust to start from the second option
                      allWeightOpts[i].disabled = true;
                      if (allWeightOpts[i].selected) {
                          allWeightOpts[0].disabled = false;
                          allWeightOpts[0].selected = true;
                      }
                  }
                  for (let i = allWeightOpts.length - 3; i < allWeightOpts.length; i++) {
                      allWeightOpts[i].disabled = false;
                  }
              }
          }
        }
    }
};